export default __webpack_public_path__ + "static/media/akshay_singh.0814881c.jpeg";